<script>
  import viewport from '@/js/utils/useViewportAction.js';

  import ResourcesItem from './Item.svelte';
  export let items;
  export let desc;
  let grow = false;
</script>

<section
  class="resources container container--large"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  <p class="resources__desc tagline">{desc}</p>
  <div class="resources__items flexbox-full">
    {#each items as item}
      <div class="resources__item-and-line col col-20 col-m-33 col-s-50">
        <ResourcesItem {item} />
        <div
          class="line-vertical"
          class:grow
          use:viewport
          on:enterViewport={() => (grow = true)}
        />
      </div>
    {/each}
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes grow {
    0% {
      height: 0%;
      top: 50%;
    }

    90% {
      height: 110%;
      top: -5%;
    }

    100% {
      height: 100%;
      top: 0%;
    }
  }
  .resources {
    padding-top: 0;
    padding-bottom: 0;

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    &__desc {
      text-align: center;
      margin: 0 auto;
      color: var(--royal-light);
    }

    &__items {
      margin-top: 3rem;
      justify-content: center;
      row-gap: 3rem;
    }

    &__item-and-line {
      position: relative;
      &:nth-child(5) > .line-vertical {
        display: none;
      }

      @include resp-range('s', 'm') {
        &:nth-child(3) > .line-vertical {
          display: none;
        }
      }

      @include resp-max('s') {
        &:nth-child(2) > .line-vertical {
          display: none;
        }

        &:nth-child(4) > .line-vertical {
          display: none;
        }
      }

      .line-vertical {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;

        &.grow {
          animation: grow ease-in-out 1s;
        }
      }
    }
  }
</style>
